import React, { useEffect, useState } from "react";
import axios from "axios";

 import { useNavigate } from "react-router-dom";

export default function UpdateCrd() {
  const [crdList, setCrdList] = useState([]);
  const [search, setSearch] = useState("");
  const token = sessionStorage.getItem("token");
  const navigate = useNavigate();
  /* ===============================
      FETCH ALL CRD
  =============================== */
  const fetchCRD = async () => {
    try {
      const res = await axios.get("https://irc.zentelex.com/api/delete/crd", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setCrdList(res.data.data || []);
    } catch (error) {
      console.error(error);

    }
  };

  useEffect(() => {
    fetchCRD();
  }, []);

  /* ===============================
      DELETE CRD
  =============================== */
  




    

  const filteredCrdList = crdList.filter((item) => {
    const text = search.toLowerCase();

    return (
      item.crdNo?.toLowerCase().includes(text) ||
      item.clientName?.toLowerCase().includes(text) ||
      item.warehouseName?.toLowerCase().includes(text) ||
      item.commodityName?.toLowerCase().includes(text)
    );
  });

  return (
    <div className="container mt-4">
      <h4 className="mb-4 fw-bold">Update CRD Records</h4>

      <div className="mb-3">
        <input
          type="text"
          className="form-control border-primary"
          placeholder="🔍 Search CRD / Client / Warehouse / Product..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>CRD No</th>
              <th>Client Name</th>
              <th>Warehouse</th>
              <th>Product</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {filteredCrdList.length > 0 ? (
              filteredCrdList.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.crdNo}</td>
                  <td>{item.clientName}</td>
                  <td>{item.warehouseName}</td>
                  <td>{item.commodityName}</td>

                  <td>
                   <button
                   className="btn btn-warning btn-sm"
                   onClick={() =>
                   navigate(`/commodity-received-document/edit/${item.id}`)
                    }
                   >
                 ✏️ Update
               </button>
                   
		  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
